import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="flex items-center justify-between flex-wrap bg-white p-4 mb-3">
      <div
        style={{ height: 30, width: 120, position: "relative" }}
        className="flex items-center flex-shrink-0 text-white mr-6"
      >
        {/* <span className="font-semibold text-xl tracking-tight">Booketh</span> */}
        <img
          style={{
            height: 40,
            width: 50,
            position: "absolute",
            marginLeft: 15,
          }}
          src="https://cdn-icons-png.flaticon.com/512/2972/2972979.png"
          alt=""
        />
      </div>
      <div className="block lg:hidden">
        <button
          onClick={handleToggle}
          className="flex items-center px-3 py-2 border rounded text-red-200 border-red-400 hover:text-green-500 hover:border-cyan-400 "
        >
          <svg
            className="fill-current h-3 w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* <title>Menu</title> */}
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        className={`w-full block flex-grow lg:flex lg:items-center lg:w-auto ${
          isOpen ? "block" : "hidden"
        }`}
      >
        <div className="text-sm lg:flex-grow">
          <Link
            to="/"
            className="text-base block mt-4 lg:inline-block lg:mt-0 hover:text-red-500 mr-4 font-medium"
          >
            Home
          </Link>
          <Link
            to="/men"
            className="text-base block mt-4 lg:inline-block lg:mt-0 hover:text-red-500 mr-4 font-medium"
          >
            Men
          </Link>
          <Link
            to="/women"
            className="text-base block mt-4 lg:inline-block lg:mt-0 hover:text-red-500 mr-4 font-medium"
          >
            Women
          </Link>
          <Link
            to="/electronics"
            className="text-base block mt-4 lg:inline-block lg:mt-0  hover:text-red-500 mr-4 font-medium"
          >
            Electronics
          </Link>
          <Link
            to="/wishlist"
            style={{
              position: "absolute",
              right: 115,
              display: "flex",
              top: 20,
              flexDirection: "column",
            }}
          >
            <img
              className="h-6 w-7 lg:inline-block"
              src="https://cdn-icons-png.flaticon.com/512/2767/2767018.png"
              alt=""
            />
            wish
          </Link>
          <Link
            to="/cartitems"
            style={{
              position: "absolute",
              right: 70,
              top: 20,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <img
              className="h-6 lg:inline-block"
              src="https://cdn-icons-png.flaticon.com/512/1656/1656850.png"
              alt=""
            />
            cart
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
